/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MembershipAffiliationDto } from './MembershipAffiliationDto';
import {
    MembershipAffiliationDtoFromJSON,
    MembershipAffiliationDtoFromJSONTyped,
    MembershipAffiliationDtoToJSON,
    MembershipAffiliationDtoToJSONTyped,
} from './MembershipAffiliationDto';

/**
 * 
 * @export
 * @interface GetMembershipAffiliationsResponseDto
 */
export interface GetMembershipAffiliationsResponseDto {
    /**
     * 
     * @type {Array<MembershipAffiliationDto>}
     * @memberof GetMembershipAffiliationsResponseDto
     */
    items: Array<MembershipAffiliationDto>;
}

/**
 * Check if a given object implements the GetMembershipAffiliationsResponseDto interface.
 */
export function instanceOfGetMembershipAffiliationsResponseDto(value: object): value is GetMembershipAffiliationsResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetMembershipAffiliationsResponseDtoFromJSON(json: any): GetMembershipAffiliationsResponseDto {
    return GetMembershipAffiliationsResponseDtoFromJSONTyped(json, false);
}

export function GetMembershipAffiliationsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMembershipAffiliationsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(MembershipAffiliationDtoFromJSON)),
    };
}

export function GetMembershipAffiliationsResponseDtoToJSON(json: any): GetMembershipAffiliationsResponseDto {
    return GetMembershipAffiliationsResponseDtoToJSONTyped(json, false);
}

export function GetMembershipAffiliationsResponseDtoToJSONTyped(value?: GetMembershipAffiliationsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(MembershipAffiliationDtoToJSON)),
    };
}

